import { CopConstants } from "../../constants/cop-constants";
import { DOMHelper } from "../../helpers/dom-helper";
import { RecommendationDto } from "../../marketing-client-bigdata";
import { CollectionIdsObject, CtaObject, Utils } from "../utils";
import { ArticleParameters } from "./recommendations-cop";

export default class CopBox {
    elements: CopElements;
    boxIndex: number;
    downloadRecommendation: boolean;
    articleParameters: ArticleParameters = {
        articleId: 0,
        pageUrl: ""
    };
    imageFormat: string = "";

    constructor(boxIndex: number, downloadFlag: boolean) {
        this.boxIndex = boxIndex;
        this.downloadRecommendation = downloadFlag;
    }

    init() {
        this.initializeElements();
    }

    prepareBox(recommendation: RecommendationDto | null, ctaObject: CtaObject, collectionIdsObject: CollectionIdsObject, pageViewId: string) {
        if (this.downloadRecommendation && recommendation && this.checkIfAllElementsExist() && this.checkIfRecoHasValuesInRequiredFields(recommendation)) {
            const recoUrl = this.buildRecommendationUrl(recommendation.url, ctaObject, collectionIdsObject, pageViewId)
            this.assignRecommendationData(recommendation, recoUrl);
            this.getParameters(recommendation);
        }
        else {
            this.setParametersForPlanB();
            this.setUrlForPlanB();
        }
    }

    assignImageFormat(ddboxIsVisible: boolean, isMobile: Boolean): string {
        if (ddboxIsVisible) {
            return CopConstants.ddboxGraphicFormat;
        }

        if (isMobile) {
            return CopConstants.swimmerMobileGraphicFormat;
        }

        return CopConstants.swimmerDesktopGraphicFormat;
    }

    initializeElements() {
        this.elements = {
            image: DOMHelper.querySelector(`${CopConstants.box}${this.boxIndex} ${CopConstants.boxImg}`) as HTMLImageElement,
            title: DOMHelper.querySelector(`${CopConstants.box}${this.boxIndex} ${CopConstants.boxHeader} `) as HTMLElement,
            description: DOMHelper.querySelector(`${CopConstants.box}${this.boxIndex} ${CopConstants.boxDescription} `) as HTMLElement,
            anchors: DOMHelper.querySelectorAsArray(`${CopConstants.box}${this.boxIndex} ${CopConstants.boxRecommendationAnchor}`) as HTMLAnchorElement[],
            readLaterButton: DOMHelper.querySelector(`${CopConstants.bookmark}${this.boxIndex}`) as HTMLElement
        };
    }

    buildRecommendationUrl(url: string, ctaObject: CtaObject, collectionIdsObject: CollectionIdsObject, pageViewId: string) {
        let urlWithAnalytics = new URL(url);
        const cta = `cta=${ctaObject.cta}`,
            actionId = `actionId=${collectionIdsObject.actionId}`,
            campaignId = `campaignId=${collectionIdsObject.campaignId}`,
            touchPointId = `touchpointId=${collectionIdsObject.touchPointId}`,
            art_pvid = `art_pvid=${pageViewId}`,
            tile = `tile=${this.boxIndex + 1}`;

        urlWithAnalytics.hash += `${urlWithAnalytics.hash.length ? "&" : ""}${cta}&${actionId}&${campaignId}&${touchPointId}&${art_pvid}&${tile}`;
        return urlWithAnalytics.href;
    }

    assignRecommendationData(reco: RecommendationDto, recoUrl: string) {
        const { title, lead, params, photoUrl } = reco;

        this.elements.image.src = Utils.changeFormatImg(photoUrl, this.imageFormat)!;
        this.elements.image.alt = params.tagName;
        this.elements.title.textContent = title;
        this.elements.description.textContent = lead;
        this.elements.anchors.forEach((el: HTMLAnchorElement) => { el.href = recoUrl });
    }

    checkIfAllElementsExist(): boolean {
        return Boolean(this.elements?.image && this.elements.title && this.elements.description && this.elements.anchors)
    }

    checkIfRecoHasValuesInRequiredFields(recommendation: RecommendationDto) {
        return Boolean(recommendation.title && recommendation.lead && recommendation.photoUrl && recommendation.url)
    }

    getParameters(reco: RecommendationDto) {
        this.articleParameters.articleId = reco.id;
        this.articleParameters.pageUrl = reco.url;
    }

    setParametersForPlanB() {
        if (this.elements?.anchors[0].href) {
            this.articleParameters.articleId = Number(this.elements.anchors[0].href.split(",")[2]);
            this.articleParameters.pageUrl = this.elements.anchors[0].href;
        }
    }

    setUrlForPlanB() {
        this.elements.anchors.forEach((el: HTMLAnchorElement) => {
            let urlWithAnalytics = new URL(el.href);
            urlWithAnalytics.hash += `${urlWithAnalytics.hash.length ? "&" : ""}tile=${this.boxIndex + 1}`;

            el.href = urlWithAnalytics.href;
        });
    }
}

export interface CopElements {
    image: HTMLImageElement,
    title: HTMLElement,
    description: HTMLElement,
    anchors: Array<HTMLAnchorElement>,
    readLaterButton: HTMLElement
}